import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
// import { useRouter } from "next/router";
import { useHistory } from "react-router";

import { getMessages } from "../../Store/actions/index";
import Messages from "../../Components/Messages/MessagesPage2";
import MessagesLoader from "../../Components/Messages/MessagesLoader";
// import Empty from "../components/Search/Empty/Empty";
import Layout from "../../Hoc/Layout/Layout";
import Conversation from "../../Components/Chat/Conversation";

export default function Chat() {
  const router = useHistory();

  const { messages, messageLoading, error } = useSelector(
    (state) => state.Messages
  );

  const { user } = useSelector((state) => state.Auth);

  const [bigScreen, setBigScreen] = useState(false);

  const [chatId, setChatId] = useState(null);

  const dispatch = useDispatch();

  const mainTile = {
    fontSize: "3.4rem",
    fontWeight: "bold",
    color: "#11141A",
  };

  const afterMainTile = {
    fontSize: "1.4rem",
    color: "#7F8FA4",
  };

  useEffect(() => {
    if (user) dispatch(getMessages());
  }, [user]);

  useEffect(() => {
    const token = localStorage.getItem("idToken");
    if (!token) router.push("/");
    if (typeof window !== "undefined")
      setBigScreen(window.innerWidth > 1200 ? true : false);
    const listner = window.addEventListener("resize", () => {
      if (window.innerWidth > 992) setBigScreen(true);
      else setBigScreen(false);
    });
    return () => window.removeEventListener("resize", listner);
  }, []);

  return (
    <Layout>
      <Container fluid={true} style={{ height: "100%" }}>
        <Row className="mt-4">
          <Col>
            <h1 style={mainTile}>Message</h1>
            <h4 style={afterMainTile} className="mb-4">
              Check Messages from your potential customers
            </h4>
          </Col>
        </Row>
        <Row className="my-5">
          <Col xl="4">
            {messageLoading && (
              <>
                <MessagesLoader />
                <MessagesLoader />
                <MessagesLoader />
                <MessagesLoader />
              </>
            )}

            {!messageLoading && messages && messages.length !== 0 && (
              <Messages
                bigScreen={bigScreen}
                setChatId={setChatId}
                messages={messages}
                chatId={chatId}
              />
            )}

            {/* {(!messageLoading && messages.length) === 0 && (
              <>
                <Empty message="You don't have any messages currently" />
                empyt
              </>
            )} */}
          </Col>
          <Col className="d-none d-xl-block" xl="8">
            <Conversation chatId={chatId} messageLoading={messageLoading} />
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
